import React, { useState } from "react"
import { Button } from "reactstrap"
import { seasonLabel } from "./plannerQuery"
import { sportLabel } from "./plannerLabels"
import { seasonPeriod } from "./generationRequest"
import GapCells from "./GapCells"

// The Calendar's gaps read (Phase D3): a country, the season's own days and the view's sports.
export const gapsPath = query => "/admin/competitive-calendar/gaps?" + new URLSearchParams({ country: query.country, ...seasonPeriod(query.season),
  sportType: query.sports.join(",") })

// „Goluri (n)” on the Calendar tab (ticket 17): the season's gaps, collapsed until opened. Information only; a gap concerns the area's players,
// so the category, organizer and place filters leave it as it is.
export default function CalendarGaps({ read, query }) {
  const [open, setOpen] = useState(false)
  const gaps = read.data?.gaps
  return <section className="ep-card ep-information" aria-label="Gaps">
    <button type="button" className="ep-information-toggle" aria-expanded={open} aria-controls="ep-gaps" onClick={() => setOpen(!open)}>
      <i className="bx bx-map-alt" aria-hidden="true" /><b>{gaps ? `Gaps (${gaps.length})` : "Gaps"}</b>
      <span className="ep-meta">{`Areas and months with tournaments last season and nothing planned · ${query.country} · ${seasonLabel(query.season)} (${
        query.season.startsWith("winter") ? "November–March" : "April–October"}) · ${query.sports.map(sportLabel).join(", ")}`}</span>
      <i className={"bx ep-information-chevron " + (open ? "bx-chevron-up" : "bx-chevron-down")} aria-hidden="true" />
    </button>
    {open && <div id="ep-gaps" className="ep-information-body">
      {read.error && <span className="text-danger">{read.error}{" "}
        <Button color="link" className="p-0 align-baseline" onClick={read.reload}>Retry</Button></span>}
      {!gaps && !read.error && <span className="ep-meta">Loading the gaps…</span>}
      {gaps && <GapCells gaps={gaps} planner={query} bothSports={query.sports.length > 1} />}
    </div>}
  </section>
}
